import React from 'react';
import propTypes from 'prop-types';
import Modal from 'tailwind-components/Modal/Modal';
import Button from 'tailwind-components/Button/Button';

const ACTION_CONFIG = {
  approve: {
    title: 'Approve offboarding?',
    confirmText: 'Approve',
    confirmVariant: 'success'
  },
  deny: {
    title: 'Deny offboarding?',
    confirmText: 'Deny',
    confirmVariant: 'danger'
  }
};

function SecondApprovalConfirmModal({
  record,
  action,
  open,
  onClose,
  onConfirm,
  isSubmitting = false
}) {
  if (!record) return null;

  const config = ACTION_CONFIG[action] ?? ACTION_CONFIG.approve;

  return (
    <Modal
      active={open}
      closeModal={onClose}
      title={config.title}
      size='medium'
      footer={
        <div className='flex w-full flex-wrap justify-end gap-2'>
          <Button
            variant='secondary'
            text='Go back'
            onClick={onClose}
            size='small'
            isDisabled={isSubmitting}
          />
          <Button
            variant={config.confirmVariant}
            text={config.confirmText}
            onClick={() => onConfirm(record, action)}
            size='small'
            isLoading={isSubmitting}
            isDisabled={isSubmitting}
          />
        </div>
      }
    >
      <div className='flex flex-col gap-3 text-left'>
        <p className='m-0 rounded-md border border-grey-lighter bg-grey-lightest px-3 py-2 text-sm font-medium text-black'>
          This action cannot be undone.
        </p>
        <dl className='m-0 grid gap-2 text-sm'>
          <div>
            <dt className='m-0 text-xs font-medium uppercase tracking-wide text-grey'>
              Agent
            </dt>
            <dd className='m-0 font-semibold text-black'>
              {record.agentName || '—'}
            </dd>
          </div>
          <div>
            <dt className='m-0 text-xs font-medium uppercase tracking-wide text-grey'>
              NPN
            </dt>
            <dd className='m-0 font-mono text-black'>{record.NPN || '—'}</dd>
          </div>
          <div>
            <dt className='m-0 text-xs font-medium uppercase tracking-wide text-grey'>
              Agency
            </dt>
            <dd className='m-0 text-black'>{record.agencyName || '—'}</dd>
          </div>
        </dl>
      </div>
    </Modal>
  );
}

SecondApprovalConfirmModal.propTypes = {
  record: propTypes.object,
  action: propTypes.oneOf(['approve', 'deny']),
  open: propTypes.bool.isRequired,
  onClose: propTypes.func.isRequired,
  onConfirm: propTypes.func.isRequired,
  isSubmitting: propTypes.bool
};

export default SecondApprovalConfirmModal;
